// extracted by mini-css-extract-plugin
export var modalFooter = "_ps-0";